import { render, staticRenderFns } from "./ResultHeader.vue?vue&type=template&id=3f7a0a40&scoped=true"
import script from "./ResultHeader.vue?vue&type=script&lang=js"
export * from "./ResultHeader.vue?vue&type=script&lang=js"
import style0 from "./ResultHeader.vue?vue&type=style&index=0&id=3f7a0a40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7a0a40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7a0a40')) {
      api.createRecord('3f7a0a40', component.options)
    } else {
      api.reload('3f7a0a40', component.options)
    }
    module.hot.accept("./ResultHeader.vue?vue&type=template&id=3f7a0a40&scoped=true", function () {
      api.rerender('3f7a0a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/budget/components/ResultHeader.vue"
export default component.exports